// Structured data schema builders (JSON-LD)

const SITE_URL = process.env.REACT_APP_SITE_URL || "";

export function organizationSchema(settings) {
  const s = settings || {};
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: s.business_name || "SSK Enterprises",
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    description:
      "Authorised Distributor of 3AK Chemie Pvt. Ltd., supplying MR Chemie NDT materials, NDT inspection equipment, KLYDE zinc materials and industrial bearings across Telangana and Andhra Pradesh.",
    email: s.email,
    telephone: (s.phone || "").trim() || undefined,
    address: {
      "@type": "PostalAddress",
      streetAddress: s.street_address || s.address,
      addressLocality: s.locality || "Hyderabad",
      addressRegion: s.region || "Telangana",
      postalCode: s.postal_code || undefined,
      addressCountry: s.country_code || "IN",
    },
    sameAs: [s.gbp_url, s.linkedin].filter((x) => x && x !== "https://linkedin.com/"),
  };
}

export function localBusinessSchema(settings) {
  const s = settings || {};
  const phones = [s.phone, s.phone_marketing, s.phone_sales].filter(Boolean);
  return {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "Store"],
    "@id": `${SITE_URL}/#localbusiness`,
    name: s.business_name || "SSK Enterprises",
    image: `${SITE_URL}/logo512.png`,
    url: SITE_URL,
    telephone: phones[0],
    email: s.email,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: s.street_address || s.address,
      addressLocality: s.locality || "Hyderabad",
      addressRegion: s.region || "Telangana",
      postalCode: s.postal_code || undefined,
      addressCountry: s.country_code || "IN",
    },
    areaServed: [
      { "@type": "State", name: "Telangana" },
      { "@type": "State", name: "Andhra Pradesh" },
    ],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "09:30",
        closes: "18:30",
      },
    ],
    contactPoint: phones.map((p, i) => ({
      "@type": "ContactPoint",
      telephone: p,
      contactType: i === 0 ? "customer service" : i === 1 ? "marketing" : "sales",
      areaServed: "IN",
      availableLanguage: ["English", "Telugu", "Hindi"],
    })),
    sameAs: [s.gbp_url, s.linkedin].filter((x) => x && x !== "https://linkedin.com/"),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function productCollectionSchema(division, products) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${division.label} — SSK Enterprises`,
    description: division.tagline,
    url: `${SITE_URL}/products/${division.slug}`,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: (products || []).slice(0, 20).map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Product",
          name: p.name,
          description: p.short_description,
          category: p.category,
          brand: p.brand ? { "@type": "Brand", name: p.brand } : undefined,
        },
      })),
    },
  };
}
